<article>
  @if (isLoading()) {
    <app-please-wait></app-please-wait>
  }

  @if (dataTable() && !selectedAsset) {
    <app-data-table [dataTable]="dataTable()" dataTableKey="setpoint:summary" (onRowClick)="dataTableClick($event)" />
  }
</article>

@if (selectedAsset) {
  <main>
    <app-setpoint-detail [assetId]="selectedAsset.id" [rangeId]="2" (onBack)="selectedAsset = null"></app-setpoint-detail>
  </main>
}
